import dataProvider from '@pankod/refine-graphql';
import { ClientError, GraphQLClient, gql as _gql } from 'graphql-request';
import { createClient } from 'graphql-ws';
import { clientVersionHeaders } from './utilities/client-version';

// constants
export const DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN!;
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID!;
export const IDENTIFIER = process.env.REACT_APP_IDENTIFIER!;
export const API_URL = process.env.REACT_APP_API_URI!;

// Function to Get Authorization Token
const getAuthToken = () => {
  const token = localStorage.getItem('token');
  return token ? `Bearer ${token}` : '';
};

class SafeGraphQLClient extends GraphQLClient {
  async request<T = any>(query: string, variables?: any): Promise<T> {
    try {
      const token = getAuthToken();
      return await super.request<T>(query, variables, { headers: { Authorization: token } } as any);
    } catch (err: any) {
      if (err instanceof ClientError) {
        const message = err.response.errors?.[0]?.message || 'Unexpected error';
        throw new Error(message);
      }
      if (err && typeof err === 'object' && 'message' in err) {
        throw new Error(`Unexpected Error: ${(err as any).message}`);
      }
      throw new Error('An unknown error occurred');
    }
  }
}

// The version header is static; App.tsx adds authorization once the token is ready.
export const client = new SafeGraphQLClient(API_URL, { headers: clientVersionHeaders });

// Create WebSocket Connection for Subscriptions
export const wsClient = createClient({
  url: API_URL.replace('http', 'ws'), // Convert HTTP to WS
  connectionParams: {
    authorization: getAuthToken(),
    ...clientVersionHeaders,
  },
});

export const gql = _gql;
export const gqlDataProvider = dataProvider(client);
